import {
  GET_SOCIETY,
  GET_SOCIETY_SUCCESS,
  GET_SOCIETY_FAIL,
} from "./actionTypes"

export const getSociety = () => ({
  type: GET_SOCIETY,
})
export const getSocietySuccess = supplier => {
  supplier.forEach(c => {
    c.label = c.name+" | "+c.code
    c.value = c.id
  })
  return {
    type: GET_SOCIETY_SUCCESS,
    payload: supplier,
  }
}
export const getSocietyFail = error => ({
  type: GET_SOCIETY_FAIL,
  payload: error,
})
